import CrudPage, { fmtMoney } from "../components/CrudPage";
import { StatusBadge } from "../components/Shared";
import { CalendarCheck } from "@phosphor-icons/react";

const CUR_OPTS = [
  { value: "TRY", label: "₺ TRY" }, { value: "USD", label: "$ USD" }, { value: "EUR", label: "€ EUR" }, { value: "GBP", label: "£ GBP" },
];

export default function Payments() {
  return (
    <CrudPage
      title="Ödeme & Tahsilat"
      subtitle="Yaklaşan ödemeler ve beklenen tahsilatlar"
      endpoint="payments"
      exportEntity="payments"
      emptyIcon={CalendarCheck}
      testidPrefix="pay"
      fields={[
        { name: "title", label: "Başlık", full: true },
        { name: "direction", label: "Yön", type: "select", default: "payable", options: [{ value: "payable", label: "Ödeme (Borç)" }, { value: "receivable", label: "Tahsilat (Alacak)" }] },
        { name: "status", label: "Durum", type: "select", default: "pending", options: [{ value: "pending", label: "Bekliyor" }, { value: "paid", label: "Ödendi" }] },
        { name: "amount", label: "Tutar", type: "number" },
        { name: "currency", label: "Para Birimi", type: "select", default: "TRY", options: CUR_OPTS },
        { name: "due_date", label: "Vade Tarihi", type: "date" },
        { name: "bank_account_id", label: "Kasa / Banka Hesabı (boş bırakılırsa aynı para birimindeki hesap otomatik güncellenir)", type: "select", optionsEndpoint: "bank-accounts", optionValue: "id", optionLabel: "name", allowEmpty: true, full: true },
      ]}
      columns={[
        { key: "title", label: "Başlık" },
        { key: "direction", label: "Yön", render: (i) => (
          <span className={`px-2.5 py-1 rounded-full text-xs font-medium ${i.direction === "receivable" ? "bg-emerald-500/15 text-emerald-400" : "bg-rose-500/15 text-rose-400"}`}>
            {i.direction === "receivable" ? "Tahsilat" : "Ödeme"}
          </span>
        ) },
        { key: "due_date", label: "Vade" },
        { key: "status", label: "Durum", render: (i) => <StatusBadge status={i.status} /> },
        { key: "amount", label: "Tutar", align: "right", render: (i) => fmtMoney(i.amount, i.currency) },
      ]}
    />
  );
}
